export default __webpack_public_path__ + "static/media/amit.95175cfa.jpg";